
import Vue from 'vue';
import Component from 'vue-class-component';
import { Mixins, Watch } from 'vue-property-decorator';
import milestone from '@/components/FormComponents/milestoneComponent.vue'
import dailyReport from '@/components/FormComponents/DailyReports/parentDailyReport.vue'
import budgetUploads from '@/components/FormComponents/budgetUploads.vue'
import milestoneTable from '@/components/FormComponents/milestoneTable.vue'
import UserProvisioning from '@/mixins/userProvisioning';

@Component({
    components: {
        milestone,dailyReport,budgetUploads,milestoneTable
    },
    filters: {
        prettydate(passedDate: any) {
            if(!passedDate && passedDate === null) return;
            if(typeof(passedDate)=="string")return passedDate
            let passedMonth = ((passedDate.getMonth()+1)>9)?(passedDate.getMonth()+1):'0'+(passedDate.getMonth()+1)
            let passedDay = ((passedDate.getDate())>9)?(passedDate.getDate()):'0'+(passedDate.getDate())
            return passedDate.getFullYear()+"-"+passedMonth+"-"+passedDay
        }
    }
})

export default class ActivityPane extends Mixins(UserProvisioning) {
    private activityModel = {
        id: "",
        name: "",
        start: "",
        end: "",
        parentActivityId: "",
        departmentId: null,
        operationUnitId: null,
        wellActivityId: null,
        activityDependencyId: null,
        duration: 0,
        isRigMove: false
    };
    private deletePromptProperty: boolean = false;
    private milestone: boolean = false;
    private dailyReport: boolean = false;
    private budget: boolean = false;
    private milestoneTable: boolean = false;
    view = 'General'

    get selectedSequence() {
        return this.$store.getters['projectModule/getSelectedSequence']
    }

    get milestones () {
        return this.$store.getters['MilestoneModule/getMilestonesForActivity']
    }

    get selectedProject() {
        return this.$store.getters['projectModule/getSelectedProject']
    }

    get getProjectIndexById(){
        return this.$store.getters["projectModule/getProjectIndexById"](this.selectedProject.id)
    }

    get getActivitiesForProject(){
        return this.$store.getters["ActivityModule/getActivitiesForProject"](this.selectedProject.id)
    }

    get activity () {
        return this.$store.getters['ActivityModule/getActiveActivity']
    }

    get activities(){
        return this.$store.getters['ActivityModule/getActivitiesForProject'](this.selectedProject.id)
    }

    get getWellActivities () {
        return this.$store.getters['wellactivitiesModule/getWellOperations']
    }

    get getWellActivityOptions () {
        return this.getWellActivities.map((data: any) => {
            return {text: data.name, value: data.id}
        })
    }

    get getOperationUnitOptions(){
        if(this.activityModel.departmentId==null||!this.activityModel.departmentId) return []
        let department = this.$store.getters["departmentModule/getDepartmentById"](this.activityModel.departmentId)
        if(department) return department.operationUnits.map((t:any)=>({text:t.name,value:t.id}))
        return []
    }

    get getActivityDepedencyOptions(){
        let thisActivityStartTime = new Date(this.activityModel.start).getTime()
        return this.getActivitiesForProject
        .filter((thisActivity:any) => (
        new Date(thisActivity.end).getTime()<=thisActivityStartTime)&&this.activityModel.id!=thisActivity.id)
        .map((thisFilteredActivity:any) => {
            return {text:thisFilteredActivity.wellActivity.name,value:thisFilteredActivity.id}
        })
    }

    //methods
    addDays(date: string, daysToAdd: any): string {
        let result: Date;

        if (typeof date === "string") {
            const [year, month, day] = date.split('-').map(Number);
            result = new Date(Date.UTC(year, month - 1, day));
        } else {
            result = new Date(date);
        }

        if (daysToAdd === "") return result.toISOString().split('T')[0];
        result.setUTCDate(result.getUTCDate() + Number.parseInt(daysToAdd));

        if (isNaN(result.getTime())) {
            return '';
        }
        return result.toISOString().split('T')[0];
    }

    // addDays(date: string, daysToAdd: number): string {
    //     let result: Date;

    //     if (typeof date === "string") {
    //         const [year, month, day] = date.split('-').map(Number);
    //         result = new Date(Date.UTC(year, month - 1, day));
    //     } else {
    //         result = new Date(date);
    //     }

    //     // Use fractional days if applicable
    //     const integerDays = Math.floor(daysToAdd);
    //     const fractionalDays = daysToAdd - integerDays;

    //     result.setUTCDate(result.getUTCDate() + integerDays);

    //     // Add fractional days in hours to maintain precision
    //     result.setUTCHours(result.getUTCHours() + fractionalDays * 24);
    //     return result.toISOString();
    // }

    otherTabFunction (tabName: string) {
        this.view = tabName
    } 

    deleteItemClicked(data:any){
        this.$store.commit('MilestoneModule/deleteMilestone', data)
    }

    editItem(data: any) {
        this.milestone = true
    }

    computeDuration(startDate:string,endDate:string){
        if(startDate==""||endDate=="")return 0;
        const start = new Date(startDate);
        const end = new Date(endDate);

        // Calculate the difference in time (milliseconds)
        const diffTime = end.getTime() - start.getTime();

        // Convert the difference from milliseconds to days
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

        return diffDays;
    }

    // computeDuration(startDate: string, endDate: string) {
        
    //     if (startDate === "" || endDate === "") return 0;
    //     const start = new Date(startDate);
    //     const end = new Date(endDate);
    //     // Calculate the difference in time (milliseconds)
    //     const diffTime = end.getTime() - start.getTime();

    //     // Convert the difference from milliseconds to days (with fractional parts)
    //     const diffDays = diffTime / (1000 * 60 * 60 * 24);

    //     return diffDays; // This will return the precise number of days, including decimals
    // }


    computeTotalDuration(start: string, duration: number) {
        if(start==""||duration==0)return 0
        let end:any = this.addDays(start, Number(duration))
        let startDateMill = (new Date(start)).getTime()
        let endDateMill = (new Date(end)).getTime()
        let diff = endDateMill - startDateMill
        if(diff<1)return 1
        return Math.round(diff/(1000 * 3600 * 24))
    }

    calculateDurationFromDays = (duration: number): string => {
        // Get the whole number of days
        const totalDays = Math.floor(duration);
        
        // Get the fractional part and convert it to hours
        const fractionalDays = duration - totalDays;
        const hours = Math.round(fractionalDays * 24); // Convert fraction to hours
        
        return `${totalDays} day${totalDays !== 1 ? 's' : ''} and ${hours} hour${hours !== 1 ? 's' : ''}`;
    };

    onOperationUnitChanged(){
        this.$store.dispatch('ActivityModule/updateActivity',{sequenceId:this.selectedSequence.Id,projectIndex:this.getProjectIndexById,id:this.activityModel.id,operationUnitId:this.activityModel.operationUnitId})
    }

    OnNamePropertyChanged(){
        this.$store.dispatch('ActivityModule/updateActivity',{sequenceId:this.selectedSequence.Id,projectIndex:this.getProjectIndexById,id:this.activityModel.id,name:this.activityModel.name})
    }

    OnDurationPropertyChanged(newVal:number){
        let newEndDate:any = this.addDays(this.activityModel.start,this.activityModel.duration)
        this.activityModel.end = newEndDate
        this.$store.dispatch('ActivityModule/updateActivity',{sequenceId:this.selectedSequence.Id,projectIndex:this.getProjectIndexById,id:this.activityModel.id,end:this.activityModel.end})
    }         

    OnStartDateChanged(){
        this.$store.dispatch('ActivityModule/updateActivity',{sequenceId:this.selectedSequence.Id,projectIndex:this.getProjectIndexById,id:this.activityModel.id,start:this.activityModel.start})
        this.activityModel.duration = this.computeDuration(this.activityModel.start,this.activityModel.end)
    }

    OnEndDateChanged(){
        this.$store.dispatch('ActivityModule/updateActivity',{sequenceId:this.selectedSequence.Id,projectIndex:this.getProjectIndexById,id:this.activityModel.id,end:this.activityModel.end})
        this.activityModel.duration = this.computeDuration(this.activityModel.start,this.activityModel.end)
    }

    onWellActivityChanged(newVal:any){
        let wellActivity = this.getWellActivities.find((wa:any) => wa.id==this.activityModel.wellActivityId)
        this.$store.dispatch('ActivityModule/updateActivity',{sequenceId:this.selectedSequence.Id,projectIndex:this.getProjectIndexById,id:this.activityModel.id,wellActivity:wellActivity})
    }

    onActivityDependencyChanged(newVal:any){
        this.$store.dispatch('ActivityModule/updateActivity',{sequenceId:this.selectedSequence.Id,projectIndex:this.getProjectIndexById,id:this.activityModel.id,activityDependencyId:this.activityModel.activityDependencyId})
    }

    onRigMoveShow(newValue: boolean){
        this.$store.dispatch('ActivityModule/updateActivity', {
            sequenceId: this.selectedSequence.Id,
            projectIndex: this.getProjectIndexById,
            id: this.activityModel.id,
            isRigMove: newValue
        })
    }

    closePropertyGrid(){
        this.$store.commit("setRightPaneToFalse")
    }

    doDelete() {
        this.$store.dispatch('ActivityModule/deleteActivity', {sequenceId:this.selectedSequence.Id,projectIndex:this.getProjectIndexById,id:this.activityModel.id})
        this.$store.commit('setRightPaneToFalse')
    }

    @Watch("activity",{immediate:true,deep:true})
    onActivityChanged(){
        if(this.activity){
            
            this.activityModel.id = this.activity.id
            this.activityModel.parentActivityId = this.activity.parentActivityId
            this.activityModel.departmentId = this.activity.departmentId
            this.activityModel.start = this.activity.start
            this.activityModel.end = this.activity.end
            this.activityModel.wellActivityId = this.activity.wellActivity.id
            this.activityModel.name = this.activity.wellActivity.name
            this.activityModel.operationUnitId = this.activity.operationUnitId
            this.activityModel.duration = this.computeDuration(this.activity.start,this.activity.end)
            this.activityModel.activityDependencyId = this.activity.activityDependencyId?this.activity.activityDependencyId:null
            this.activityModel.isRigMove = this.activity.isRigMove

            //before attempting to load milestones from backend, first
            if(this.activity.milestones.length>0){
                if(this.$store.getters["MilestoneModule/getMilestonesForActivity"].length<1)this.$store.dispatch("MilestoneModule/getMilestonesForActivity")
            }
        }
    }

    @Watch("milestones",{ immediate: true, deep: true })
    onMilestonesChanged(){
        if (this.milestones && this.milestones.length > 0) {
            const totalMilestoneDuration = this.milestones.reduce((total: any, milestone: any) => {
                return total + (Number(milestone.duration) || 0);
            }, 0);
            if (totalMilestoneDuration > this.activityModel.duration) {
                //
            } else {
                //
            }
        }
    }

    mounted () {  
        
        if (this.getWellActivities.length == 0) {
            this.$store.dispatch('wellactivitiesModule/getWellActivities')
        }
        if(this.$store.state.departmentModule.departments,length<1){
            this.$store.dispatch("departmentModule/getDepartments")
        }
    }
}
